import { mergeSlotProps } from '@mui/material/utils';
import type { ComponentType, HTMLAttributes } from 'react';

import { ListboxComponent } from './AutoCompleteVirtualize';
import { RHFAutoComplete } from './RHFAutoComplete';
import type { RHFAutocompleteProps } from './types';

export const RHFAutoCompleteVirtualize = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  name,
  key,
  slotProps,
  ...rest
}: RHFAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>): JSX.Element => {
  return (
    <RHFAutoComplete
      name={name}
      key={key}
      disableListWrap
      {...rest}
      slotProps={{
        ...slotProps,
        listbox: mergeSlotProps(slotProps?.listbox, {
          component: ListboxComponent as ComponentType<HTMLAttributes<HTMLElement>>,
        }),
      }}
    />
  );
};
